import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {updateAccelerator} from "../../../actions/Accelerator";

import ButtonBlue from '../../controls3.0/button/ButtonBlue'
import ButtonGray from "../../controls3.0/button/ButtonGray";
import TextArea from "../../v3/Textarea/index";


class Step15 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accelerator: props.accelerator,
            errors: {}
        }
    }

    componentDidMount() {

    }

    onChange = (e) => {
        let name = e.target.name,
            value = e.target.value;
        value = value.cleanWhitespace()

        if(value.length > 1000){
            this.setState({errors: {...this.state.errors, [name]: 'The text is too long, 1000 symbols max'}});
            value = value.slice(0, 1000);
        } else {
            const err = this.state.errors;
            delete err[name];
            this.setState({errors: {}})
        }



        this.setState({accelerator: {...this.state.accelerator, [name]: value}})
    }

    update = (nextStep, onlyStep) => {
        let obj = this.state.accelerator;
        if (onlyStep) {
            obj = {}
        }

        if (!onlyStep) this.setState({loading: true})
        const acceleratorId = this.state.accelerator.id;
        this.props.updateAccelerator(obj, acceleratorId, onlyStep, nextStep)
            .catch(err => {
                this.setState({loading: false})
            })
    }

    render() {
        let {accelerator, errors} = this.state

        return (
            <React.Fragment>
                <div className="step-1 is-startup">

                    <div className="block-reg-startup-step-2 padding-reg">
                        <div className="container-full-reg" style={{position: 'relative'}}>
                            <div className="container-step-1-reg">
                                <p className="text-h1 color-text-reg-gray margin-0 shell-margin-bottom-15">
                                    Startups in focus
                                </p>
                                <p className="text-h5 color-text-reg-gray margin-0 shell-margin-bottom-25"
                                   style={{fontSize: '20px', maxWidth: '620px'}}>
                                    Please describe the type of projects you are currently looking for.
                                </p>
                                <p className="text-h6 color-text-reg-gray margin-0 shell-margin-bottom-40"
                                   style={{fontSize: '20px', maxWidth: '720px'}}>
                                    This will help you to find with the startup teams that correspond with your professional interests so that both sides had a more effective output from the collaboration.
                                </p>


                                <div className="block-text-area-form-add-edit-modal-reg-expert"
                                     style={{maxWidth: '620px'}}>
                                    {/*<p className="title shell-margin-bottom-5">*/}
                                        {/*Terms of the deal*/}
                                    {/*</p>*/}


                                    <TextArea name={'startupsFocus'} val={accelerator.startupsFocus}
                                              onChange={this.onChange} placeholder={`Ex.: My investment criteria include the following parameters ...\n1 000 symbols`}
                                              defaultHeight={240}
                                              widthClass={'container-full-reg'}
                                              widthClass2={'block-text-area-form-add-edit-modal-reg-expert mw620'}
                                              noPopUp={true}
                                              error={errors.startupsFocus}
                                    />

                                    {/*<textarea name="startupsFocus"*/}
                                              {/*value={accelerator.startupsFocus}*/}
                                              {/*onChange={this.onChange}*/}
                                              {/*placeholder={'Ex.: My investment criteria include the following parameters ...'}*/}
                                              {/*style={{height: '240px'}}*/}
                                    {/*></textarea>*/}
                                {/*<Textarea name="startupsFocus"*/}
                                              {/*val={accelerator.startupsFocus}*/}
                                              {/*onChange={this.onChange}*/}
                                              {/*placeholder={'Ex.: My investment criteria include the following parameters ...'}*/}
                                              {/*defaultHeight={240}*/}
                                    {/*></Textarea>*/}
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                <div className="block-fix-button-reg-bottom fix-button-double-details-one" style={{height:'130px'}}>
                    <div className="container-full-reg" style={{textAlign:'right'}}>
                        <div className="block-button-right">
                            <ButtonBlue
                                TitleButton={'Save & Continue'}
                                EventOnClick={() => this.update(15)}
                                paddingButton={'54'}
                                disabled={!this.state.accelerator.startupsFocus || Object.keys(errors).length}
                                loader={this.state.loading}
                            />
                        </div>

                        {/*<div className="block-details" style={{padding: '0 40px 0 0', verticalAlign: 'top'}}>*/}
                        {/*<ButtonGray*/}
                        {/* TitleButton={'Skip this step'}*/}
                        {/*EventOnClick={() => this.update(15, true)}*/}
                        {/*paddingButton={'24'}*/}
                        {/*disabled={false}*/}
                        {/*/>*/}
                        {/*</div>*/}

                        <div className="block-button-left">
                            <ButtonGray
                                TitleButton={'Back'}
                                EventOnClick={() => this.update(13, true)}
                                paddingButton={'55'}
                                disabled={false}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    accelerator: state.accelerator
})

Step15.propTypes = {
    updateAccelerator: PropTypes.func.isRequired
}

export default connect(mapStateToProps, {updateAccelerator})(Step15)